module.exports = __webpack_public_path__ + "fonts/ubuntu-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Ubuntu/ubuntu-regular-webfont.woff
// module id = 3468
// module chunks = 0